import type { NewCourseCardProps } from '@/app/modules/course/components/NewCourseCard'
import { ICost } from '@/types/course'
import type { ICourseHit } from '@/types/search'
import { AvailableLanguages } from '../../shared/providers/LanguageSelectionProvider'

export function adaptCourseCollectionToCourseCard<L extends AvailableLanguages>(
  courseFields: Pick<
    ICourseHit,
    | 'id'
    | 'education_provider'
    | 'instructors'
    | 'level'
    | 'min_price'
    | `name_${L}`
    | `learning_description_${L}`
  >,
  locale: AvailableLanguages = 'en'
): NewCourseCardProps['course'] {
  const educationProvider = {
    _id: courseFields?.education_provider.id ?? '',
    name: courseFields?.education_provider.name ?? '',
    logoUrl: courseFields?.education_provider.logo_url ?? '',
  }

  const instructors = Array.isArray(courseFields?.instructors)
    ? courseFields.instructors.map((instructor) => ({
        name: instructor.name ?? '',
        avatarUrl: instructor.avatar_url ?? '',
        role: '', // not supported by the search index yet
      }))
    : []

  return {
    _id: courseFields?.id ?? '',
    name: courseFields?.[`name_${locale}`] ?? '',
    learningDescription: courseFields?.[`learning_description_${locale}`] ?? '',
    educationProvider,
    instructors,
    cost: courseFields?.min_price as ICost,
    level: courseFields?.level,
  }
}
